import {
  AUTH_NEW_PASSWORD_ERROR,
  AUTH_NEW_PASSWORD_RESPONSE,
  AUTH_CHANGE_PASSWORD_MODAL,
  AUTH_SIGN_OUT_RESPONSE,
  AUTH_SIGN_IN,
  AUTH_SIGN_IN_RESPONSE,
  AUTH_SIGN_IN_ERROR,
  AUTH_MFA_REQUIRED,
  AUTH_SIGN_UP,
  AUTH_SIGN_UP_RESPONSE,
  AUTH_SIGN_UP_ERROR,
  AUTH_FORGOT_PASSWORD_ERROR,
  AUTH_FORGOT_PASSWORD_RESPONSE,
  AUTH_ACCEPT_INVITE_RESPONSE,
  AUTH_ACCEPT_INVITE_ERROR,
} from 'constants/AuthConstants'

import InitialState from 'constants/InitialState'

var _ = require('underscore');

function getAuthErrorFromPayload(payload) {
  if ( payload && payload.errors && payload.errors.length > 0)
    return payload.errors[0];
  else if ( payload && payload.error && typeof payload.error === 'string' )
    return payload.error
}

function getAuthError(action) {
  return getAuthErrorFromPayload(action.data);
}

function authReducer(action, state = InitialState)
{
  if ( !action ) return state;

  switch (action.actionType)
  {
    case AUTH_SIGN_OUT_RESPONSE:
    {
      return InitialState;
    }
    break;
    case AUTH_NEW_PASSWORD_ERROR:
    {
      // Only a 422 carries errors.full_messages; a 401/500/network failure
      // has a different (or no) payload and used to crash the page here.
      const errors = action.data && action.data.errors;
      const validationMessage = errors && errors.full_messages && errors.full_messages[0];
      return {
          ...state,
          passwordState: {
            ...state.passwordState,
            success: false,
            message: validationMessage || getAuthError(action) || "Problems changing password, please try again"
          }
      }
    }
    break;
    case AUTH_NEW_PASSWORD_RESPONSE:
    {
      return {
        ...state,
        passwordState: {
          show: false,
          success: true,
          message: action.data.message,
        }
      }
    }
    break;
    case AUTH_CHANGE_PASSWORD_MODAL:
    {
      if ( action.data.show )
      {
        return {
          ...state,
          passwordState: {
            show: true
          }
        }
      }
      else {
        return {
          ...state,
          passwordState: {
            ...state.passwordState,
            show: false
          }
        }
      }
    }
    break;
    case AUTH_SIGN_UP_RESPONSE:
    case AUTH_SIGN_UP:
    {
      return {
        ...state,
        signupState: {
          show: false,
          message: null,
        }
      }
    }
    break;
    case AUTH_SIGN_UP_ERROR:
    {
      let errorMessage = null;
      if ( action.data.errors && 'full_messages' in action.data.errors )
      {
        errorMessage = action.data.errors.full_messages[0];
      }

      errorMessage = errorMessage || getAuthError(action) || "Problems signing up, please try again";

      return {
        ...state,
        signupState: {
          show: true,
          message: errorMessage,
        }
      }
    }
    break;
    case AUTH_SIGN_IN_ERROR:
    {
      var errorMessage = getAuthError(action) || "Problems logging in, please try again";

      return {
        ...state,
        loginState: {
          ...state.loginState,
          error:{
            show: true,
            message: errorMessage,
          }
        }
      }
    }
    break;
    case AUTH_SIGN_IN:
    {
      return {
        ...state,
        loginState: {
          ...state.loginState,
          error: {
            show: false
          }
        }
      }
    }
    break;
    case AUTH_SIGN_IN_RESPONSE:
    {
      return {
        ...state,
        loginState: {
          error: {
            show: false
          },
          mfaRequired: false,
          mfaEmail: null
        }
      }
    }
    break;
    case AUTH_MFA_REQUIRED:
    {
      const hasError = !!action.data.error;
      return {
        ...state,
        loginState: {
          ...state.loginState,
          mfaRequired: true,
          mfaEmail: action.data.email,
          error: {
            show: hasError,
            message: action.data.error || null
          }
        }
      }
    }
    break;
    case AUTH_FORGOT_PASSWORD_RESPONSE:
    {
      return {
        ...state,
        errorDict:{
          ...state.errorDict,
          [AUTH_FORGOT_PASSWORD_ERROR]:{},
        }
      }
    }
    break;
    case AUTH_ACCEPT_INVITE_RESPONSE:
    {
      var d = new Date();
      return {
        ...state,
        inviteState:{
          lastInvite: d.getTime(),
          success:true,
          user:action.data.user,
        },
        errorDict:{
          ...state.errorDict,
          [AUTH_ACCEPT_INVITE_ERROR]:{},
        }
      }
    }
    break;
    case AUTH_ACCEPT_INVITE_ERROR:
    {
      let message = null;
      if ( action.errors && action.errors.errors )
      {
        const errors = action.errors.errors;
        if ( errors.length > 0 )
        {
          message = errors[0];
        }
      }

      return {
        ...state,
        inviteState:{
          ...state.inviteState,
          success:false,
        },
        errorDict: {
          ...state.errorDict,
          [AUTH_ACCEPT_INVITE_ERROR]:{
            error: true,
            message: message
          }
        }
      }
    }
    break;
    case AUTH_FORGOT_PASSWORD_ERROR:
    {

      let message = getAuthErrorFromPayload(action.errors) || null;

      return {
        ...state,
        errorDict: {
          ...state.errorDict,
          [AUTH_FORGOT_PASSWORD_ERROR]:{
            error: true,
            message: message
          }
        }
      }
    }
    break;
    default:
      return state;
  }
}

export default authReducer
